import React from 'react';
import { formatDate } from '../../../../utils/dateUtils';
import { ServiceAgreementV2 } from '../../eBankingTempTypes';
import { ProductDetailRows } from './ProductDetailRows';
import { isActiveReferralServiceDefinitionId } from '../../privateBankingServiceDefinitionIds';
import { useTranslation } from 'react-i18next';

type DetailsBlockProps = { product: ServiceAgreementV2 };

export const DetailsBlock: React.FC<DetailsBlockProps> = ({ product }) => {
  const { t } = useTranslation();
  const activationDateLabel = isActiveReferralServiceDefinitionId(product.serviceDefinitionId)
    ? t('pb.productdetails.activeReferralWp.activationDate')
    : 'Active since';
  const detailItems = [
    { label: 'Created by', value: product.createdBy ?? '-', testId: 'product-detail-created-by' },
    { label: activationDateLabel, value: formatDate(product.activeSince), testId: 'product-detail-active-since' },
    { label: 'Closure date', value: formatDate(product.closureDate), testId: 'product-detail-closure-date' },
  ];

  return <ProductDetailRows rows={detailItems} />;
};
